'use strict';

var _ = require('lodash');
var AdvancedHepGridReloadConfigurationCacheService = function AdvancedHepGridReloadConfigurationCacheService(hepService) {
  function reloadConfigurationCacheForType(type) {
    switch (type) {
      case 'FOMarketList':
        hepService.loadFoMarkets();
        break;
      case 'DA_FareBrandDefinition':
        hepService.loadDAFareBrandDefinitions();
        break;
    }
  }
  return {
    reloadConfigurationCacheForType: reloadConfigurationCacheForType
  };
};
AdvancedHepGridReloadConfigurationCacheService.$inject = ['HepService'];
module.exports = AdvancedHepGridReloadConfigurationCacheService;